<ngx-loading-bar
  [color]="'#9F59B1'"
  [includeSpinner]="false"
  [height]="'4px'"
></ngx-loading-bar>
<app-loader></app-loader>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<a
  href="https://wa.me/5493525614842?text=Hola%20vengo%20redirigido%20desde%20la%20tienda%20online%20La%20Dulceria%20de%20Caroya%20"
  target="_blank"
  class="whatsapp-float"
  aria-label="WhatsApp"
>
  <i class="fab fa-whatsapp"></i>
</a>
